;(function(){

	var $brewMethodWrapper = $('#brew-method__wrapper');

	if($brewMethodWrapper.length > 0) {

		var makeBrew = {
			$potSteps: $('#brew-process--pot'),
			$cuppaSteps: $('#cuppa-steps'),
			$brewMethodBtn: $('.brew-method__inner a'),
			$currentProcess: '',
			$allSteps: $('.brew-process__step'),
			init: false,
			alignText: function(){
				//only do this is at desktop width
				if(site.width > 768) {
					makeBrew.$allSteps
						.each(function(i){
							var $block = $(this),
								$textBlock = $block.find('.brew-process__text'),
								emptySpace = $block.innerHeight() - $textBlock.innerHeight();

							TweenLite
								.fromTo($textBlock, .3, {
									top: '50',
									opacity: 0
								},{
									top: emptySpace / 2,
									opacity: 1,
									ease: Back.easeOut.config(1.75),
									force3D: true
								});

						});
				} else {
					makeBrew.$allSteps
						.each(function(i){
							var $block = $(this),
								$textBlock = $block.find('.brew-process__text');

							TweenLite
								.fromTo($textBlock, .3, {
									opacity: 0
								},{
									opacity: 1,
									force3D: true
								});

						});
				}
			},
			applyCleverScroll: function(){
				//Clever scroll to fade in steps as you get to them
				makeBrew.$currentProcess.find($('.brew-process__step:nth-child(n+2)'))
					.cleverScroll({
						useOnce: true,
						offset: site.height / 8,
						ready: function($el){
							TweenLite
								.set($el, {
									opacity: 0
								});

						},
						onEnterViewport: function($el){
							TweenLite
								.fromTo($el, 1, {
									y: '5%'
								},{
									y: '0%',
									opacity: 1,
									ease: Cubic.easeOut
								}, .2);

								$el.next('.brew-process__divider').addClass('active');
						}
					});


			},
			hideSecondaryContent: function(){
				//secondary content
				$('.process-secondary-content')
					.cleverScroll({
						useOnce: true,
						offset: site.height / 3,
						ready: function($el){
							TweenLite
								.set($el, {
									opacity: 0,
									display: 'block'
								});

						},
						onEnterViewport: function($el){
							TweenLite
								.fromTo($el, 1, {
									y: '5%'
								},{
									y: '0%',
									opacity: 1,
									ease: Cubic.easeOut
								}, .2);

								$el.next('.brew-process__divider').addClass('active');

						}
					});
			},
			resize: function(){

				if(site.width > 768) {
					makeBrew.alignText();
				} else {
					$textBlock = $('.brew-process__text')

					TweenLite
						.set($textBlock, {
							clearProps: 'top'
						});
				}
			}
		}

		makeBrew.$brewMethodBtn.on('click', function(e){
			e.preventDefault();

			TweenLite
				.set(makeBrew.$allSteps.find('.brew-process__text'), {
					clearProps: 'all'
				});

			$('.brew-method').removeClass('brew-method--deactive');
			$('.brew-process__divider').removeClass('active');

			var $this = $(this),
				href = $this.attr("href"),
				delay = 0;

			if(makeBrew.init) {
				delay = .3;
				makeBrew.$currentProcess.find($('.brew-process__step:nth-child(n+2)')).cleverScroll( 'remove' );  //clears clever scroll reference as it gets adde don every click
			} else {
				delay = 0;
				makeBrew.hideSecondaryContent();
			}

			makeBrew.$currentProcess = $(href);

			if(makeBrew.$currentProcess.length > 0) {
				//fade out other steps
				TweenLite
					.fromTo($('.brew-process').not($(href)), .3, {
						opacity: 1,
						y: '0%'
					},{

						opacity: 0,
						y: '5%',
						ease: Back.easeOut.config(1.75),
						force3D: true,
						onComplete: function(){
							TweenLite
								.set($('.brew-process').not($(href)),{
									display: 'none'
								});
						}
					});

				//fade in clicked step
				TweenLite
					.set(makeBrew.$currentProcess,{
						opacity: 0,
						y: '5%',
						display: 'block'
					});

				var topY = $('.brew-method').offset().top + $('.brew-method').height();

				TweenLite
					.to($core.win, 1, {
						scrollTo:{y:topY},
						ease:Power3.easeOut
					});

				TweenLite
					.fromTo(makeBrew.$currentProcess, .4, {
						opacity: 0,

					},{
						opacity: 1,
						y: '0%',
						delay: delay,
						onComplete: function(){
							makeBrew.alignText();
						}
					});

					makeBrew.applyCleverScroll();
					makeBrew.$currentProcess.find('li:first-child').next('.brew-process__divider').addClass('active');
					makeBrew.init = true;
			}

		});

		site.resize.after['how-to-make'] = makeBrew.resize;

	}

}());
